// 帳號與金幣經濟規則（伺服器以此為準，畫面只拿來顯示）
// 對應 docs/PRD-Freemium.md 第 4 節；數值調整只改這裡

import { BetPlans, type IBetPlan } from '@core/game-set';
import { TableId, type TTableId } from '@core/table-catalog';

export const NEWBIE_GIFT = 10_000; // 新手禮
export const SIGNIN_REWARD = 2_000; // 每日簽到
export const SIGNIN_STREAK_REWARD = 5_000; // 連續第 7 天
export const CARD_SIGNIN_REWARD = 5_000; // 月卡會員每日簽到
export const CARD_SIGNIN_STREAK_REWARD = 10_000; // 月卡會員連續第 7 天
export const SIGNIN_STREAK_DAYS = 7; // 連續幾天給大獎，之後重新累計
export const RELIEF_REWARD = 2_000; // 救濟金
export const RELIEF_PER_DAY = 2; // 救濟金每天次數
export const FREE_SETS_PER_DAY = 2; // 免費玩家每天可開幾將（三桌共用）
export const TABLE_FEE_MULTIPLIER = 2; // 進階桌與高手桌桌費＝底注 × 2
export const NPC_STARTING_BALANCE = 1_000_000; // AI 牌友每將起始金幣（不會輸光）
export const LEDGER_RECENT_LIMIT = 50; // 快照附帶的最近帳目筆數
export const DAY_OFFSET_MS = 8 * 60 * 60 * 1000; // 以台灣時間（UTC+8）換日

export interface ITableEconomy {
  readonly threshold: number; // 入座門檻
  readonly planIndexes: readonly number[]; // 可選的底台（BetPlans 索引）
  readonly fee: boolean; // 是否收桌費
}

export const TABLE_ECONOMY: Record<TTableId, ITableEconomy> = {
  [TableId.Beginner]: { threshold: 1_000, planIndexes: [0, 1], fee: false },
  [TableId.Intermediate]: { threshold: 20_000, planIndexes: [2, 3], fee: true },
  [TableId.Expert]: { threshold: 100_000, planIndexes: [4], fee: true },
};

/** 救濟金門檻：金幣不夠最低一檔的「底＋一台」。 */
export const RELIEF_THRESHOLD = BetPlans[0].base + BetPlans[0].taiUnit;

export const tableFeeFor = (tableId: TTableId, bet: IBetPlan): number =>
  TABLE_ECONOMY[tableId].fee ? bet.base * TABLE_FEE_MULTIPLIER : 0;

/** 台灣時間的日期字串（YYYY-MM-DD），每日次數以此換日。 */
export const dayKey = (now: number): string =>
  new Date(now + DAY_OFFSET_MS).toISOString().slice(0, 10);

export const previousDayKey = (now: number): string => dayKey(now - 24 * 60 * 60 * 1000);
